import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Redux and persist store imports
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// Without Redux and Persist store wrapper
// ReactDOM.render(
//     <App />,
//   document.getElementById("root")
// );
